import { Component, OnInit, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-blog-landing',
  imports: [CommonModule, RouterLink],
  templateUrl: './blog-landing.component.html',
  styleUrl: './blog-landing.component.scss'
})
export class BlogLandingComponent implements OnInit {
  
  blogsApiBaseUrl: string;

  constructor() {
    this.blogsApiBaseUrl = environment.blogsApiBaseUrl;
  }

  private http = inject(HttpClient);

  message = 'Loading...';
  blogs: any;

  ngOnInit() {

    // Get Blog Posts
    this.http.get<{ results: any[] }>(this.blogsApiBaseUrl + '/blogs').subscribe({
      next: (res) => {
        this.blogs = res.results.map(post => ({
          ...post,
          blogDescription: this.stripHtmlAndTruncate(post.postBody, 100)
        }));
      },
      error: (err) => {
        this.blogs = [];
      }
    });

  }

  formatJson(data: any): string {
    return JSON.stringify(data, null, 2);
  }

  stripHtmlAndTruncate(html: string, limit: number = 100): string {
    const text = html
      .replace(/<[^>]+>/g, '')         // remove HTML tags
      .replace(/\s+/g, ' ')            // collapse all whitespace/newlines to single space
      .trim();                         // remove leading/trailing spaces

    return text.length > limit ? text.substring(0, limit) + '...' : text;
  }



}
